"use client";

import { createTheme } from "@mui/material";
import NextLink from 'next/link';
import { forwardRef } from 'react';
import { idID } from '@mui/material/locale';

const LinkBehaviour = forwardRef<HTMLAnchorElement, any>(function LinkBehaviour(props, ref) {
  return <NextLink ref={ref} href={props.href} {...props} />;
});

// @ts-ignore
export const globalTheme = createTheme({
  typography: {
    fontFamily: [
      'var(--font-poppins)',
      'Roboto',
      'Arial',
      'sans-serif'
    ].join(','),
    button: {
      textTransform: "none"
    }
  },
  palette: {
    primary: {
      main: '#023d8a'
    },
    secondary: {
      main: '#FF8D28'
    }
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehaviour
      }
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehaviour
      }
    }
  }
}, idID);